import { render, staticRenderFns } from "./ValeCampaignPage.vue?vue&type=template&id=5f4f2f2a&scoped=true"
import script from "./ValeCampaignPage.vue?vue&type=script&lang=js"
export * from "./ValeCampaignPage.vue?vue&type=script&lang=js"
import style0 from "./ValeCampaignPage.vue?vue&type=style&index=0&id=5f4f2f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f2f2a",
  null
  
)

export default component.exports